module.exports = __webpack_public_path__ + "img/Gd.a97efced.png";